<template>
  <div id="app">
    <keep-alive exclude='servicedetail,partydetail,culturedetail,charactdetail'>
    <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      navlist:{
        about:[
          {
            path:'/about/introduction',
            name:'社区图'
          },
          {
            path:'/about/honour',
            name:'社区荣誉',
          },
          {
            path:'/about/leader',
            name:'领导关怀'
          },
          {
            path:'/about/media',
            name:'媒体报道',
          }
        ]
      }
    }
  }
}
</script>

<style>

</style>
